import { render, staticRenderFns } from "./GraphDetail20.vue?vue&type=template&id=9b3a576e&scoped=true"
import script from "./GraphDetail20.vue?vue&type=script&lang=js"
export * from "./GraphDetail20.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3a576e",
  null
  
)

export default component.exports